/** Figma `57:2`'s full listing page, linked from the popover's last row. */
export const SWITCH_ALL_PATH = '/mudar';
